import { CheckboxChangeEvent } from 'antd/es/checkbox';
import React, { useEffect, useState } from 'react';

import { Button, Checkbox, Flex, Text } from 'src/client/components';

import * as S from './styles';

type Props = {
  open: boolean;
  onCancel: () => void;
  onContinue: (dontShowAgain: boolean) => void;
};

function TogetherViewInfoModal(props: Props) {
  const { open, onCancel, onContinue } = props;

  const [dontShowAgain, setDontShowAgain] = useState(false);

  useEffect(() => {
    if (!open) {
      setDontShowAgain(false);
    }
  }, [open]);

  function handleCancel() {
    onCancel();
  }

  function handleDontShowAgainChange(e: CheckboxChangeEvent) {
    setDontShowAgain(e.target.checked);
  }

  function handleContinue() {
    onContinue(dontShowAgain);
  }

  return (
    <S.StyledModal
      closable={false}
      footer={false}
      open={open}
      onCancel={onCancel}
    >
      <S.ImageCover src="/together-view-intro.png" />
      <S.Container>
        <Text type="h3med2">Introducing Giving Side’s Together View</Text>
        <Text type="body2reg2">
          Your gallery’s <S.ItalicText>Together View</S.ItalicText> lets you
          display a small curated set of up to six recipients.
          <br />
          <br />
          We’ve designed this quick view to help you and other Giving Side
          members you know have an easy starting point for conversations about a
          few of the things you care deeply about.
          <br />
          <br />
          This view won’t change your full gallery. It simply creates a useful
          simplified - and perhaps democratized - gallery for all of us who
          give.
          <br />
          <br />
          With love, <br />
          Mario, Rose, WaG
        </Text>
      </S.Container>
      <S.FooterContainer>
        <Checkbox checked={dontShowAgain} onChange={handleDontShowAgainChange}>
          Do not show this message again
        </Checkbox>

        <Flex alignItems="center" gap="8px">
          <Button type="secondary" onClick={handleCancel}>
            Cancel
          </Button>
          <Button type="primary" onClick={handleContinue}>
            Continue
          </Button>
        </Flex>
      </S.FooterContainer>
    </S.StyledModal>
  );
}

export default TogetherViewInfoModal;
